var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-google-map',{class:_vm.cssClass,attrs:{"center":_vm.center,"zoom":_vm.zoom}},[_c('vue-google-marker',{attrs:{"position":_vm.center,"clickable":false,"draggable":false}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b19b6dd","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/GoogleMap.vue
// module id = YhX3
// module chunks = 0